import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-face-compare-loader',
  imports: [CommonModule],
  templateUrl: './face-compare-loader.component.html',
  styleUrl: './face-compare-loader.component.css',
})
export class FaceCompareLoaderComponent {
  @Input() isLoading: boolean = false;
  @Input() loadingText: string = 'Loading...';
}
